import { UserTask } from '@hefe/models';
import { UserApi } from '@hefe/store';
import CustomList from '../../core/components/custom-list/custom-list.component';
import UserTaskListItemComponent from '../components/user-task-list-item/user-task-list-item.component';

export default function UserTasksPage() {
  const { data, isFetching: isFetchingTasks } =
    UserApi.useFetchUserTasksQuery();

  return (
    <CustomList
      id="user-tasks"
      loading={isFetchingTasks}
      dataSource={data}
      renderItem={(userTask: UserTask) => (
        <UserTaskListItemComponent userTask={userTask} />
      )}
    />
  );
}
